import React from "react"

import classNames from "classnames"

import { RJSFSchema } from "shared/types/RJSF"
import { Label } from "shared/ui/label/Label"

interface RJSFFormObjectFieldWrapperFactoryProps {
  schema: RJSFSchema
  children: React.ReactNode
  childrenCount?: number
  hasObjectChildren?: boolean
  className?: string
  valueClassName?: string
}

export const RJSFFormObjectFieldWrapperFactory = React.memo(
  ({
    schema,
    children,
    childrenCount,
    hasObjectChildren,
    className,
    valueClassName
  }: RJSFFormObjectFieldWrapperFactoryProps) => (
    <div
      className={classNames(
        "form-field",
        "object-field",
        {
          "single-child": childrenCount === 1,
          "object-children": hasObjectChildren
        },
        schema?.meta?.displayType,
        className
      )}
    >
      {schema.title ? (
        <div className="object-field__label">
          <Label>{schema.title}</Label>
        </div>
      ) : null}
      <div
        className={classNames(
          "object-field__value",
          {
            "single-child": childrenCount === 1,
            "object-children": hasObjectChildren
          },
          valueClassName
        )}
      >
        {children}
      </div>
    </div>
  )
)
